import { memo } from "react";
import OTPInput from "react-otp-input";

export default memo(
  ({
    otp,
    onChange,
  }: {
    otp: string;
    onChange: (newValue: string) => void;
  }) => {
    return (
      <OTPInput
        value={otp}
        onChange={onChange}
        numInputs={4}
        renderSeparator={<span style={{ width: "30px" }}></span>}
        inputType="number"
        shouldAutoFocus={true}
        inputStyle={{
          // border: "1px solid transparent",
          borderRadius: "8px",
          width: "3rem",
          height: "3rem",
          fontSize: "19px",
          color: "#000",
          fontWeight: "400",
          caretColor: "blue",
          // marginLeft: "10px",
          // marginRight: "10px",
        }}
        renderInput={(props) => <input {...props} />}
        // focusStyle={{
        //   border: "1px solid #CFD3DB",
        //   outline: "none",
        // }}
      />
    );
  }
);
